import { render } from "./EmployeeTable.vue?vue&type=template&id=af1e9878&scoped=true"
import script from "./EmployeeTable.vue?vue&type=script&lang=js"
export * from "./EmployeeTable.vue?vue&type=script&lang=js"

import "./EmployeeTable.vue?vue&type=style&index=0&id=af1e9878&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1e9878"]])

export default __exports__